<script setup>
import { defineEmits, onMounted, onBeforeUnmount } from "vue";

const emit = defineEmits(["close"]);

const closeModal = () => {
  emit("close");
};

const { it_id } = defineProps(["it_id"]);

// 다른 다이얼로그(VDialog)와 같이 ESC로 닫고, 열려 있는 동안 배경 스크롤을 막는다
const onKeydown = (event) => {
  if (event.key === "Escape") closeModal();
};

onMounted(() => {
  window.addEventListener("keydown", onKeydown);
  document.body.style.setProperty("overflow", "hidden");
});

onBeforeUnmount(() => {
  window.removeEventListener("keydown", onKeydown);
  document.body.style.removeProperty("overflow");
});
</script>

<template>
  <div class="receipt-overlay" @click.self="closeModal">
    <div
      class="receipt-panel"
      role="dialog"
      aria-modal="true"
      aria-labelledby="receipt-title"
    >
      <div class="receipt-head">
        <h3 id="receipt-title" class="receipt-title">영수증 확인</h3>
        <button
          type="button"
          class="receipt-close"
          aria-label="닫기"
          @click="closeModal"
        >
          <font-awesome-icon icon="fa-solid fa-xmark" />
        </button>
      </div>

      <iframe
        id="inicisIframe"
        title="영수증"
        :src="'https://iniweb.inicis.com/receipt/iniReceipt.jsp?noTid=' + it_id"
        class="receipt-frame"
        frameborder="0"
        scrolling="yes"
      ></iframe>
    </div>
  </div>
</template>

<style scoped>
.receipt-overlay {
  @apply fixed inset-0 z-[100] flex items-center justify-center bg-black/40 p-4;
}

.receipt-panel {
  @apply flex h-[min(85vh,48rem)] w-[min(32rem,calc(100vw-2rem))] flex-col overflow-hidden rounded-2xl bg-white text-left shadow-xl;
}

.receipt-head {
  @apply flex shrink-0 items-center justify-between gap-4 border-b border-gray-100 bg-white px-5 py-3.5;
}

.receipt-title {
  @apply text-lg font-bold tracking-tight text-gray-900;
}

.receipt-close {
  @apply -mr-2 flex h-10 w-10 items-center justify-center rounded-lg text-lg text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-700;
}

/* 남은 높이를 모두 채운다 */
.receipt-frame {
  @apply block w-full grow basis-0 border-0 px-2;
}
</style>
